// extracted by mini-css-extract-plugin
export var infoRow = "_o5-2";
export var labelContainer = "_o5-0";
export var rightInfo = "_o5-1";